"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeLine = void 0;
const preact_1 = require("preact");
const style_1 = require("./style");
class TimeLine extends preact_1.Component {
    constructor(props) {
        super(props);
        this.onPostUpdate = () => {
            const duration = this.props.game.getTimelineDuration();
            this.setState({
                progress: duration > 0 ? this.props.game.getTimelineTime() / duration : 0
            });
        };
        this.onClick = (e) => {
            const rects = e.currentTarget.getClientRects()[0];
            const progress = 1 - (rects.right - e.pageX) / (rects.right - rects.left);
            this.props.game.seekAllByPercent(progress * 100);
            this.props.game.pauseAll();
        };
        this.onMouseEnter = () => {
            this.setState({
                ghostKnobActive: true
            });
        };
        this.onMouseMove = (e) => {
            if (!this.state.ghostKnobActive) {
                return;
            }
            const rects = e.currentTarget.getClientRects()[0];
            const progressPos = 1 - (rects.right - e.pageX) / (rects.right - rects.left);
            const pos = progressPos * 100 + '%';
            this.setState({
                ghostKnobPos: pos
            });
        };
        this.onMouseLeave = () => {
            this.setState({
                ghostKnobActive: false
            });
        };
        this.state = {
            progress: 0,
            ghostKnobActive: false,
            ghostKnobPos: '0%',
            onPostUpdate: null
        };
    }
    componentDidMount() {
        this.offPostUpdate = this.props.game.events.on('postupdate', this.onPostUpdate);
    }
    componentWillUnmount() {
        if (this.offPostUpdate) {
            this.offPostUpdate();
        }
    }
    render() {
        const timePos = this.state.progress * 100;
        const knobOff = timePos + '%';
        const lineOff = 100 - timePos + '%';
        return ((0, preact_1.h)("div", { class: style_1.TimeLine.timeline, onClick: this.onClick, onMouseEnter: this.onMouseEnter, onMouseMove: this.onMouseMove, onMouseLeave: this.onMouseLeave },
            (0, preact_1.h)("div", { class: style_1.TimeLine.ghostLine }),
            (0, preact_1.h)("div", { class: style_1.TimeLine.line, style: { right: lineOff } }),
            (0, preact_1.h)("div", { class: style_1.TimeLine.knob, style: { left: knobOff } }),
            (0, preact_1.h)("div", { class: style_1.TimeLine.ghostKnob, style: { left: this.state.ghostKnobPos } })));
    }
}
exports.TimeLine = TimeLine;
